import { useAuthStore } from "@/store/auth-store";
import { Spinner } from "./ui/spinner";
import { Navigate, useLocation } from "react-router-dom";

export function AuthCallback() {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const location = useLocation();

  // Safe Guard
  const from = location.state?.from?.pathname || "/";
  if (isAuthenticated) return <Navigate to={from} replace />;

  return (
    <div className="flex items-center justify-center min-h-screen">
      <Spinner>Checking Authentication...</Spinner>
    </div>
  );
}
